<template>
  <b-row>
    <b-col lg="6">
      <b-form-group
        id="input-group-8"
        :label="$t('polls.target')"
        label-for="input-8"
      >
        <validation-provider
          #default="{ errors }"
          name="target"
          vid="target"
          rules="required"
        >
          <select v-model="target" id="target" class="form-control">
            <option value="">
              {{ $t("site.choose") }} {{ $t("announcements.target") }}
            </option>
            <option value="all_teachers_and_students">
              {{ $t("announcements.all_teachers_and_students") }}
            </option>
            <option value="all_teachers">
              {{ $t("announcements.all_teachers") }}
            </option>
            <option value="all_students">
              {{ $t("announcements.all_students") }}
            </option>
            <option value="all_students_in_edu_program">
              {{ $t("announcements.all_students_in_edu_program") }}
            </option>
            <option value="all_in_edu_courses">
              {{ $t("announcements.all_in_edu_courses") }}
            </option>
            <option value="all_students_in_room">
              {{ $t("announcements.all_students_in_room") }}
            </option>
            <option value="all_teachers_in_edu_program">
              {{ $t("announcements.all_teachers_in_edu_program") }}
            </option>
            <option value="all_teachers_in_room">
              {{ $t("announcements.all_teachers_in_room") }}
            </option>
          </select>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      lg="6"
      v-if="
        target == 'all_teachers_in_room' || target == 'all_students_in_room'
      "
    >
      <b-form-group
        id="input-group-1"
        :label="$t('rooms.rooms')"
        label-for="input-1"
      >
        <validation-provider
          #default="{ errors }"
          name="room"
          vid="room"
          rules="required"
        >
          <b-form-select
            v-model="room"
            :options="rooms"
            v-text="name"
            :placeholder="$t('edu_programs.rooms')"
            text-field="name"
            value-field="id"
          />

          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col lg="6" v-if="target == 'all_in_edu_courses'">
      <b-form-group
        id="input-group-1"
        :label="$t('edu_courses.edu_courses')"
        label-for="input-1"
      >
        <validation-provider
          #default="{ errors }"
          name="edu_courses"
          vid="edu_courses"
          rules="required"
        >
          <b-form-select
            v-model="edu_course"
            :options="edu_courses"
            :placeholder="$t('edu_courses.edu_courses')"
              text-field="name"
            value-field="id"
          />

          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      lg="6"
      v-if="
        target == 'all_teachers_in_edu_program' ||
        target == 'all_students_in_edu_program'
      "
    >
      <b-form-group
        id="input-group-1"
        :label="$t('edu_programs.edu_programs')"
        label-for="input-1"
      >
        <validation-provider
          #default="{ errors }"
          name="edu_program"
          vid="edu_program"
          rules="required"
        >
          <b-form-select
            v-model="edu_program"
            :options="edu_programs"
            text-field="name"
            value-field="id"
            :placeholder="$t('edu_programs.edu_programs')"
          />

          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import EduProgramsController from "@/Controllers/EduProgramsController";
import RoomsController from "@/Controllers/RoomsController";
import EduCoursesController from '@/Controllers/EduCoursesController';
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      rooms: [],
      edu_programs: [],
      target: "",
      room: "",
      edu_program: "",
      edu_courses:[],
      edu_course:""
    };
  },
  async created() {
    this.edu_programs = await new EduProgramsController().GetAll();
    this.rooms = await new RoomsController().GetAll();
    this.edu_courses = await new EduCoursesController().GetAll()//.filter(a=>a.);
    console.log(this.edu_courses);
  },
  methods: {
    getData() {
      return {
        target: this.target,
        room: this.room,
        edu_program: this.edu_program,
        edu_course:this.edu_course
      };
    },
  },
};
</script>

<style>
</style>